import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardHeader, CardText, CircularProgress, Paper,
} from 'material-ui';
import { gql, graphql } from 'react-apollo';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const TravelStatusQuery = gql`
query TravelStatusQuery($startDate: String!, $endDate: String!) {
  allTrips(startDate: $startDate, endDate: $endDate) {
    edges {
      node {
        id,
        tripName,
        dateString,
        startDate,
        endDate,
      }
    }
  }
}
`;

@graphql(TravelStatusQuery, {
  options: {
    variables: {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(14, 'days').format('YYYY-MM-DD'),
    },
  },
})
class TravelStatus extends React.Component {
  static propTypes = {
    data: PropTypes.shape().isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedDay: moment(props.data.variables.startDate).format('DDMMM').toUpperCase(),
    };
  }

  selectDay = selectedDay => () => {
    this.setState({ selectedDay });
  }

  render() {
    const { data, className } = this.props;

    if (data.loading) {
      return (<div style={styles.cardStyles}>
        <Card className={css(styles.progressContainer)}>
          <CardHeader title='Departures and returns' />
          <CircularProgress className={css(styles.progressIndicator)} />
        </Card>
      </div>);
    }

    const { allTrips: { edges: trips }, variables: { startDate, endDate } } = data;
    const momentStartDate = moment(startDate);
    const momentEndDate = moment(endDate);
    const dateRange = moment.range(startDate, endDate);

    const departuresByDay = {};
    const returnsByDay = {};
    trips.forEach(({ node: trip }) => {
      const tripStartDate = moment(trip.startDate);
      const tripEndDate = moment(trip.endDate);
      let key;
      let list;
      if (momentStartDate <= tripStartDate || momentEndDate > tripStartDate) {
        key = tripStartDate.format('DDMMM').toUpperCase();
        list = departuresByDay[key] || [];
        list.push(trip);
        departuresByDay[key] = list;
      }
      if (momentStartDate <= tripEndDate || momentEndDate > tripEndDate) {
        key = tripEndDate.format('DDMMM').toUpperCase();
        list = returnsByDay[key] || [];
        list.push(trip);
        returnsByDay[key] = list;
      }
    });

    const { selectedDay } = this.state;
    const departing = departuresByDay[selectedDay] || [];
    const returning = returnsByDay[selectedDay] || [];

    return (<Card className={className}>
      <CardHeader
        title='Departures and Returns'
        subtitle={`${momentStartDate.format('DDMMM')} - ${momentEndDate.subtract(1, 'days').format('DDMMM')}`.toUpperCase()}
      />
      <CardText className={css(styles.days)}>
        {Array.from(dateRange.by('days', { exclusive: true })).map(day => <Paper
          key={day.format()}
          className={css(styles.day)}
          onClick={this.selectDay(day.format('DDMMM').toUpperCase())}
        >
          <div className={css(styles.dayHeader)}>
            {day.format('DDMMM').toUpperCase()}
          </div>
          <div>
            {(departuresByDay[day.format('DDMMM').toUpperCase()] || []).length} departures
          </div>
          <div>
            {(returnsByDay[day.format('DDMMM').toUpperCase()] || []).length} returns
          </div>
        </Paper>)}
      </CardText>
      <CardText className={css(styles.lists)}>
        <div className={css(styles.list)}>
          <h2 className={css(styles.listHeader)}>Departing {selectedDay} ({departing.length})</h2>
          <ul>
            {departing.map(trip => (
              <li key={trip.id}>
                <Link to={`/trips/${trip.id}/`}>{trip.tripName}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className={css(styles.list)}>
          <h2 className={css(styles.listHeader)}>Returning {selectedDay} ({returning.length})</h2>
          <ul>
            {returning.map(trip => (
              <li key={trip.id}>
                <Link to={`/trips/${trip.id}/`}>{trip.tripName}</Link>
              </li>
            ))}
          </ul>
        </div>
      </CardText>
    </Card>);
  }
}

const styles = StyleSheet.create({
  progressContainer: {
    margin: 10,
    position: 'relative',
  },
  progressIndicator: {
    marginLeft: '50%',
    left: -20,
  },
  lists: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  list: {
    padding: 10,
    width: 300,
  },
  listHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  days: {
    display: 'grid',
    '@media (min-width: 775px)': {
      gridTemplateColumns: 'repeat(7, minmax(95px, 1fr))',
    },
    '@media (max-width: 775px)': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(95px, 1fr))',
    },
  },
  day: {
    padding: 5,
    margin: 5,
  },
  dayHeader: {
    fontWeight: 'bold',
  },
});

export default TravelStatus;



// WEBPACK FOOTER //
// /src/components/Widgets/TravelStatus.js